import { createContext, useContext } from 'react';

/**
 * Lets any marketing component start the "Get started" flow without
 * prop-drilling through the section tree. MarketingLayout owns the flow state
 * so a single set of dialogs is mounted per page.
 *
 * openGetStarted() shows the chooser: create a profile, a team enquiry, or a card.
 * openEnquiry(audience) skips the chooser when the context already implies the
 * answer, such as the teams page.
 */
export const GetStartedContext = createContext({
  openGetStarted: () => {},
  openEnquiry: () => {},
});

export function useGetStarted() {
  return useContext(GetStartedContext);
}

export default GetStartedContext;
